import { useDictionaryDelete } from '@/module/Author/Dictionary';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface DictionaryDeleteButtonProps {
  dictionaryId: Id;
}

export function DictionaryDeleteButton({ dictionaryId }: DictionaryDeleteButtonProps) {
  const mutation = useDictionaryDelete(dictionaryId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
